import * as React from "react";
import { SportEvent } from "./model";

import BetGeniusScorePitch from "../../BetGeniusScorePitch";
import BetGeniusStats from "../../BetGeniusStats";
import ScorePitch from "../../ScorePitch";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    sportEvent?: SportEvent;
    lang: string;
}

function SoccerLive({ sportEvent, lang }: Props): JSX.Element | null {
    if (!sportEvent) {
        return null;
    }

    const { event } = sportEvent;

    return sportEvent.betGeniusId ? (
        <div className={styles.scorecenter}>
            <BetGeniusStats
                sportEvent={sportEvent}
                lang={lang}
                component={<BetGeniusScorePitch data={event.eventPointList} />}
            />
        </div>
    ) : (
        <div className={styles.scorecenter}>
            <ScorePitch data={event.eventPointList} />
        </div>
    );
}

export default SoccerLive;
